/**
 * render the settings of How-To Schema
 */
/* eslint-env jquery */
import TypographyControl from '@Components/typography';
import WebfontLoader from '@Components/typography/fontloader';
import './style.scss';
import { __ } from '@wordpress/i18n';

import {
	AlignmentToolbar,
	BlockControls,
	InspectorControls,
	ColorPalette,
} from '@wordpress/block-editor';

import {
	PanelBody,
	SelectControl,
	RangeControl,
	ToggleControl,
	ExternalLink,
} from '@wordpress/components';

let imageSizeOptions = [
	{ value: 'thumbnail', label: __('Thumbnail') },
	{ value: 'medium', label: __('Medium') },
	{ value: 'full', label: __('Large') },
];

export default function Settings(props) {
	props = props.parentProps;

	const {
		attributes,
		setAttributes,
		attributes: {
			overallAlignment,
			showEstcost,
			showTotaltime,
			showMaterials,
			showTools,
			showTotaltimecolor,
			toolsCount,
			materialCount,
			tools,
			materials,
			mainimage,
			imgSize,
			headingColor,
			subHeadingColor,
			headingTag,
			headFontFamily,
			headFontWeight,
			headFontSubset,
			headFontSizeType,
			headFontSize,
			headFontSizeMobile,
			headFontSizeTablet,
			headLineHeightType,
			headLineHeight,
			headLineHeightMobile,
			headLineHeightTablet,
			subHeadFontFamily,
			subHeadFontWeight,
			subHeadFontSubset,
			subHeadFontSize,
			subHeadFontSizeType,
			subHeadFontSizeMobile,
			subHeadFontSizeTablet,
			subHeadLineHeight,
			subHeadLineHeightType,
			subHeadLineHeightMobile,
			subHeadLineHeightTablet,
			headLoadGoogleFonts,
			subHeadLoadGoogleFonts,
			//Total time.
			priceFontSizeType,
			priceFontSize,
			priceFontSizeTablet,
			priceFontSizeMobile,
			priceFontFamily,
			priceFontWeight,
			priceFontSubset,
			priceLineHeightType,
			priceLineHeight,
			priceLineHeightTablet,
			priceLineHeightMobile,
			priceLoadGoogleFonts,
			timeSpace,
			costSpace,
			/* eslint-disable camelcase */
			row_gap,
			step_gap,
		},
	} = props;

	/*
	 * Event to get Image as while adding.
	 */
	const getImageSize = (sizes) => {
		const sizeArr = [];
		jQuery.each(sizes, function (index) {
			const name = index;
			const p = { value: name, label: name };
			sizeArr.push(p);
		});
		return sizeArr;
	};

	if (mainimage && mainimage.sizes) {
		imageSizeOptions = getImageSize(mainimage.sizes);
	}

	let loadHeadingGoogleFonts;
	let loadSubHeadingGoogleFonts;
	let loadPriceGoogleFonts;

	if (true === headLoadGoogleFonts) {
		const hconfig = {
			google: {
				families: [
					headFontFamily +
						(headFontWeight ? ':' + headFontWeight : ''),
				],
			},
		};

		loadHeadingGoogleFonts = (
			<WebfontLoader config={hconfig}></WebfontLoader>
		);
	}

	if (true === subHeadLoadGoogleFonts) {
		const sconfig = {
			google: {
				families: [
					subHeadFontFamily +
						(subHeadFontWeight ? ':' + subHeadFontWeight : ''),
				],
			},
		};

		loadSubHeadingGoogleFonts = (
			<WebfontLoader config={sconfig}></WebfontLoader>
		);
	}

	if (true === priceLoadGoogleFonts) {
		const pconfig = {
			google: {
				families: [
					priceFontFamily +
						(priceFontWeight ? ':' + priceFontWeight : ''),
				],
			},
		};

		loadPriceGoogleFonts = <WebfontLoader config={pconfig}></WebfontLoader>;
	}

	const howtoGeneralSettings = () => {
		return (
			<PanelBody title={__('General')} initialOpen={true}>
				<SelectControl
					label={__('Primary Heading Tag')}
					value={headingTag}
					onChange={(value) => setAttributes({ headingTag: value })}
					options={[
						{ value: 'h1', label: __('H1') },
						{ value: 'h2', label: __('H2') },
						{ value: 'h3', label: __('H3') },
						{ value: 'h4', label: __('H4') },
						{ value: 'h5', label: __('H5') },
						{ value: 'h6', label: __('H6') },
					]}
				/>
				{mainimage.url && (
					<SelectControl
						label={__('Image Size')}
						options={imageSizeOptions}
						value={imgSize}
						onChange={(value) => setAttributes({ imgSize: value })}
					/>
				)}
				<hr className="wpsp-editor__separator" />
				<ToggleControl
					label={__('Show Total Time')}
					checked={showTotaltime}
					onChange={() =>
						setAttributes({ showTotaltime: !showTotaltime })
					}
					help={__(
						'Note: Time is recommended field for schema, please turn this ON to avoid warnings on your page.'
					)}
				/>
				<ToggleControl
					label={__('Show Estimated Cost')}
					checked={showEstcost}
					onChange={() =>
						setAttributes({ showEstcost: !showEstcost })
					}
					help={__(
						'Note: Cost is recommended field for schema, please turn this ON to avoid warnings on your page.'
					)}
				/>
				<ExternalLink
					href={
						'https://en.wikipedia.org/wiki/List_of_circulating_currencies'
					}
				>
					{__(
						'Click here to find ISO code for currency of your country.'
					)}
				</ExternalLink>
				<hr className="wpsp-editor__separator" />
				<ToggleControl
					label={__('Show Tools')}
					checked={showTools}
					onChange={() => setAttributes({ showTools: !showTools })}
					help={__(
						'Note: This is recommended field for schema, please turn this ON to avoid warnings on your page.'
					)}
				/>
				{showTools && (
					<RangeControl
						label={__('Number of Tools')}
						value={toolsCount}
						onChange={(newCount) => {
							const cloneIcons = [...tools];

							if (cloneIcons.length < newCount) {
								const incAmount = Math.abs(
									newCount - cloneIcons.length
								);

								{
									let i = 0;
									while (i < incAmount) {
										cloneIcons.push({
											add_required_tools:
												'- A Computer' +
												(cloneIcons.length + 1),
										});
										i += 1;
									}
								}

								setAttributes({ tools: cloneIcons });
							} else {
								const incAmount = Math.abs(
									newCount - cloneIcons.length
								);
								const dataNew = cloneIcons;
								for (let i = 0; i < incAmount; i++) {
									dataNew.pop();
								}
								setAttributes({ tools: dataNew });
							}
							setAttributes({ toolsCount: newCount });
						}}
						min={1}
						max={50}
					/>
				)}
				<hr className="wpsp-editor__separator" />
				<ToggleControl
					label={__('Show Materials')}
					checked={showMaterials}
					onChange={() =>
						setAttributes({ showMaterials: !showMaterials })
					}
					help={__(
						'Note: This is recommended field for schema, please turn this ON to avoid warnings on your page.'
					)}
				/>
				{showMaterials && (
					<RangeControl
						label={__('Number of Materials')}
						value={materialCount}
						onChange={(newCount) => {
							const cloneIcons = [...materials];

							if (cloneIcons.length < newCount) {
								const incAmount = Math.abs(
									newCount - cloneIcons.length
								);

								{
									let i = 0;
									while (i < incAmount) {
										cloneIcons.push({
											add_required_materials:
												'- A WordPress Website' +
												(cloneIcons.length + 1),
										});
										i += 1;
									}
								}

								setAttributes({ materials: cloneIcons });
							} else {
								const incAmount = Math.abs(
									newCount - cloneIcons.length
								);
								const dataNew = cloneIcons;
								for (let i = 0; i < incAmount; i++) {
									dataNew.pop();
								}
								setAttributes({ materials: dataNew });
							}
							setAttributes({ materialCount: newCount });
						}}
						min={1}
						max={50}
					/>
				)}
			</PanelBody>
		);
	};

	const howtoStyleSettings = () => {
		return (
			<PanelBody title={__('Style')} initialOpen={false}>
				<h2>{__('Colors')}</h2>
				<p className="wpsp-setting-label">
					{__('Heading')}
					<span className="components-base-control__label">
						<span
							className="component-color-indicator"
							style={{ backgroundColor: headingColor }}
						></span>
					</span>
				</p>
				<ColorPalette
					value={headingColor}
					onChange={(value) => setAttributes({ headingColor: value })}
					allowReset
				/>
				<p className="wpsp-setting-label">
					{__('Secondary Heading')}
					<span className="components-base-control__label">
						<span
							className="component-color-indicator"
							style={{ backgroundColor: showTotaltimecolor }}
						></span>
					</span>
				</p>
				<ColorPalette
					value={showTotaltimecolor}
					onChange={(value) =>
						setAttributes({ showTotaltimecolor: value })
					}
					allowReset
				/>
				<p className="wpsp-setting-label">
					{__('Description')}
					<span className="components-base-control__label">
						<span
							className="component-color-indicator"
							style={{ backgroundColor: subHeadingColor }}
						></span>
					</span>
				</p>
				<ColorPalette
					value={subHeadingColor}
					onChange={(value) =>
						setAttributes({ subHeadingColor: value })
					}
					allowReset
				/>
				<hr className="wpsp-editor__separator" />
				<h2>{__('Typography')}</h2>
				<TypographyControl
					label={__('Heading')}
					attributes={attributes}
					setAttributes={setAttributes}
					loadGoogleFonts={{
						value: headLoadGoogleFonts,
						label: 'headLoadGoogleFonts',
					}}
					fontFamily={{
						value: headFontFamily,
						label: 'headFontFamily',
					}}
					fontWeight={{
						value: headFontWeight,
						label: 'headFontWeight',
					}}
					fontSubset={{
						value: headFontSubset,
						label: 'headFontSubset',
					}}
					fontSizeType={{
						value: headFontSizeType,
						label: 'headFontSizeType',
					}}
					fontSize={{
						value: headFontSize,
						label: 'headFontSize',
					}}
					fontSizeMobile={{
						value: headFontSizeMobile,
						label: 'headFontSizeMobile',
					}}
					fontSizeTablet={{
						value: headFontSizeTablet,
						label: 'headFontSizeTablet',
					}}
					lineHeightType={{
						value: headLineHeightType,
						label: 'headLineHeightType',
					}}
					lineHeight={{
						value: headLineHeight,
						label: 'headLineHeight',
					}}
					lineHeightMobile={{
						value: headLineHeightMobile,
						label: 'headLineHeightMobile',
					}}
					lineHeightTablet={{
						value: headLineHeightTablet,
						label: 'headLineHeightTablet',
					}}
				/>
				<TypographyControl
					label={__('Secondary Heading')}
					attributes={attributes}
					setAttributes={setAttributes}
					loadGoogleFonts={{
						value: priceLoadGoogleFonts,
						label: 'priceLoadGoogleFonts',
					}}
					fontFamily={{
						value: priceFontFamily,
						label: 'priceFontFamily',
					}}
					fontWeight={{
						value: priceFontWeight,
						label: 'priceFontWeight',
					}}
					fontSubset={{
						value: priceFontSubset,
						label: 'priceFontSubset',
					}}
					fontSizeType={{
						value: priceFontSizeType,
						label: 'priceFontSizeType',
					}}
					fontSize={{
						value: priceFontSize,
						label: 'priceFontSize',
					}}
					fontSizeMobile={{
						value: priceFontSizeMobile,
						label: 'priceFontSizeMobile',
					}}
					fontSizeTablet={{
						value: priceFontSizeTablet,
						label: 'priceFontSizeTablet',
					}}
					lineHeightType={{
						value: priceLineHeightType,
						label: 'priceLineHeightType',
					}}
					lineHeight={{
						value: priceLineHeight,
						label: 'priceLineHeight',
					}}
					lineHeightMobile={{
						value: priceLineHeightMobile,
						label: 'priceLineHeightMobile',
					}}
					lineHeightTablet={{
						value: priceLineHeightTablet,
						label: 'priceLineHeightTablet',
					}}
				/>
				<TypographyControl
					label={__('Description')}
					attributes={attributes}
					setAttributes={setAttributes}
					loadGoogleFonts={{
						value: subHeadLoadGoogleFonts,
						label: 'subHeadLoadGoogleFonts',
					}}
					fontFamily={{
						value: subHeadFontFamily,
						label: 'subHeadFontFamily',
					}}
					fontWeight={{
						value: subHeadFontWeight,
						label: 'subHeadFontWeight',
					}}
					fontSubset={{
						value: subHeadFontSubset,
						label: 'subHeadFontSubset',
					}}
					fontSizeType={{
						value: subHeadFontSizeType,
						label: 'subHeadFontSizeType',
					}}
					fontSize={{
						value: subHeadFontSize,
						label: 'subHeadFontSize',
					}}
					fontSizeMobile={{
						value: subHeadFontSizeMobile,
						label: 'subHeadFontSizeMobile',
					}}
					fontSizeTablet={{
						value: subHeadFontSizeTablet,
						label: 'subHeadFontSizeTablet',
					}}
					lineHeightType={{
						value: subHeadLineHeightType,
						label: 'subHeadLineHeightType',
					}}
					lineHeight={{
						value: subHeadLineHeight,
						label: 'subHeadLineHeight',
					}}
					lineHeightMobile={{
						value: subHeadLineHeightMobile,
						label: 'subHeadLineHeightMobile',
					}}
					lineHeightTablet={{
						value: subHeadLineHeightTablet,
						label: 'subHeadLineHeightTablet',
					}}
				/>
				<hr className="wpsp-editor__separator" />
				<h2>{__('Spacing')}</h2>
				{showTotaltime && (
					<RangeControl
						label={__('Time Margin')}
						value={timeSpace}
						onChange={(value) =>
							setAttributes({ timeSpace: value })
						}
						min={0}
						max={50}
						allowReset
					/>
				)}
				{showEstcost && (
					<RangeControl
						label={__('Cost Margin')}
						value={costSpace}
						onChange={(value) =>
							setAttributes({ costSpace: value })
						}
						min={0}
						max={50}
						allowReset
					/>
				)}
				<RangeControl
					label={__('Row Gap')}
					value={row_gap}
					onChange={(value) => setAttributes({ row_gap: value })}
					min={0}
					max={500}
					allowReset
				/>
				<RangeControl
					label={__('Gap Between Steps')}
					value={step_gap}
					onChange={(value) => setAttributes({ step_gap: value })}
					min={0}
					max={500}
					allowReset
				/>
			</PanelBody>
		);
	};
	const blockControls = () => {
		return (
			<BlockControls key="index">
				<AlignmentToolbar
					value={overallAlignment}
					onChange={(value) =>
						setAttributes({ overallAlignment: value })
					}
				/>
			</BlockControls>
		);
	};
	return (
		<>
			{blockControls()}
			<InspectorControls>
				{howtoGeneralSettings()}
				{howtoStyleSettings()}
			</InspectorControls>
			{loadHeadingGoogleFonts}
			{loadSubHeadingGoogleFonts}
			{loadPriceGoogleFonts}
		</>
	);
}
